<template>
  <div class="court-list">
    <div class="court-list-header">
      <el-button type="primary" @click="handleEdit" size="mini">添加</el-button>
      <el-input v-model="where.name" placeholder="请输入法院名称" @change="pageChange(1)" style="width: 200px" size="mini" />
      <el-select v-model="where.status" placeholder="请选择状态" @change="pageChange(1)" style="width: 100px" size="mini">
        <el-option label="全部" value=""></el-option>
        <el-option label="启用" value="1"></el-option>
        <el-option label="禁用" value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="pageChange(1)" size="mini">查询</el-button>
    </div>
    <el-table :data="pageData.data" stripe border height="calc(100vh - 420px)">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="法院名称" min-width="200"></el-table-column>
      <el-table-column prop="address" label="法院地址" min-width="300"></el-table-column>
      <el-table-column prop="year_restrictions" label="年限限制" align="center" width="100"></el-table-column>
      <el-table-column prop="month_restrictions" label="月份限制" align="center" width="100"></el-table-column>
      <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1">启用</el-tag>
          <el-tag v-else type="danger">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="180"></el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
<!--          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="footer">
      <el-pagination size="mini"
        background
        @current-change="pageChange"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        layout="total, prev, pager, next"
        :total="pageData.total">
      </el-pagination>
    </div>
    <CourtEditor ref="courtEditorRef" />
  </div>
</template>

<script>
import ButlerHttp from "../../../common/ButlerHttp";
import CourtEditor from "./CourtEditor";

export default {
  name: "CourtList",
  components: {CourtEditor},
  data () {
    return {
      loading:false,
      where:{
        name:"",
        status:""
      },
      pageData:{
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
    }
  },
  mounted () {
    this.getList();
  },
  methods: {
    getList(){
      const that=this;
      that.loading=true;
      let where = {
        ...that.where
      }
      ButlerHttp.post("CourtInfo/getList?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page,{
        ...where
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      });
    },
    pageChange(page){
      this.pageData.current_page = page;
      this.getList();
    },
    handleEdit(row){
      const that = this;
      that.$refs.courtEditorRef.show(row,(data)=>{
        that.getList();
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.court-list{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/court/CourtList.vue